import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import StudentAdmission from "@/pages/StudentAdmission";
import StudentProfile from "@/pages/StudentProfile";
import Attendance from "@/pages/Attendance";
import Fees from "@/pages/Fees";
import Staff from "@/pages/Staff";
import Visitor from "@/pages/Visitor";
import FrontOffice from "@/pages/FrontOffice";
import Academic from "@/pages/Academic";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import { LessonPlanPage, AssignmentPage } from "@/pages/Academics2";
import {
  LibraryPage,
  InventoryPage,
  TransportPage,
  CommunicatePage,
} from "@/pages/MoreModules";
import Allotment from "@/pages/Allotment";
import CalendarPage from "@/pages/Calendar";
import ModernLoader from "@/components/common/ModernLoader";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <ModernLoader
        fullScreen
        title="Booting ERP"
        subtitle="Checking session and preparing modules"
      />
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/students" element={<Students />} />
            <Route path="/students/:id" element={<StudentAdmission />} />
            <Route path="/students/profile/:id" element={<StudentProfile />} />
            <Route path="/attendance" element={<Attendance />} />
            <Route path="/fees/*" element={<Fees />} />
            <Route path="/staff/*" element={<Staff />} />
            <Route path="/visitor" element={<Visitor />} />
            <Route path="/front-office/*" element={<FrontOffice />} />
            <Route path="/academic/*" element={<Academic />} />
            <Route path="/allotment" element={<Allotment />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/lesson-plan/*" element={<LessonPlanPage />} />
            <Route path="/assignment/*" element={<AssignmentPage />} />
            <Route path="/library/*" element={<LibraryPage />} />
            <Route path="/inventory/*" element={<InventoryPage />} />
            <Route path="/transport/*" element={<TransportPage />} />
            <Route path="/communicate/*" element={<CommunicatePage />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
